/**
 * region for libraries*/
import React, { Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

/**
 * region for components*/
import { Header } from './search/Header';
import { ProductRow } from './search/ProductRow';
import list from '../../../helpers/list';
import { WorkingLayer } from '../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../helpers/ajax';
import typing from '../../../helpers/typing';

/**
 * region for constans*/
import Constants from '../../../constants/Constants'

export class WebProductsSearch extends Component {
    static displayName = WebProductsSearch.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_LOADING,
            orderBy: 'IDCONTENT ASC',
            dropdownsOpen: {
                IDCONTENT: false,
                PRODUCTTITLE: false,
                BRAND_NAME: false,
                MODEL_NO: false,
                IDCLIENT: false,
                COMPANY: false
            },
            searchFilter: {},
            backofficeUrlBase: []
        };
    }


    handleToggleDropdown(dropdownName) {
        this.setState(function (prevState) {
            let _dropdowns = prevState.dropdownsOpen;
            _dropdowns[dropdownName] = !_dropdowns[dropdownName];
            return { dropdownsOpen: _dropdowns }
        });
    }

    load() {
        const self = this;

        ajax.get(Constants.ROUTE_API_COMMONDATA,
            {
                success: function (response) {
                    self.setState({
                        backofficeUrlBase: response.data.urlBackofficeBase,
                        mode: Constants.MODE_LOADED
                    });
                }
            });
    }

    componentDidMount() {
        this.load();
    }

    loadProducts() {
        const self = this;
        let requestFilter=self.state.searchFilter;
        requestFilter=typing.extend(requestFilter, { ORDERBY: self.state.orderBy});
        let requestData = {
            idContent:self.state.searchFilter.IDCONTENT,
            data: requestFilter
        };
        ajax.get(Constants.ROUTE_API_CONTENT_WEBPRODUCTS,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({
                        rows: response.data,
                        mode: Constants.MODE_LOADED
                    });
                }
            });
    }

    handleSearchChanged(searchFilter) {
        this.setState(
            {
                mode: Constants.MODE_LOADING,
                searchFilter: searchFilter
            },
            this.loadProducts
        );
    }

    handleSortClick(orderBy) {
        this.setState({
            orderBy: orderBy,
            dropdownOpenName: '',
            dropdownOpen: false,
            mode: Constants.MODE_LOADING
        },
            this.loadProducts);
    }

    getSortingDropdown(fieldName, isNumeric) {
        return <ButtonDropdown
            className="btn-group btn-group-sort"
            isOpen={this.state.dropdownsOpen[fieldName]}
            toggle={this.handleToggleDropdown.bind(this, fieldName)}>
            <DropdownToggle className="btn btn-sm btn-secondary" caret></DropdownToggle>
            {isNumeric &&
                <DropdownMenu>
                    <DropdownItem active={this.state.orderBy === `${fieldName} ASC`} onClick={this.handleSortClick.bind(this, `${fieldName} ASC`)}>Order Low  <i className="fas fa-long-arrow-alt-right"></i>  High</DropdownItem>
                    <DropdownItem active={this.state.orderBy === `${fieldName} DESC`} onClick={this.handleSortClick.bind(this, `${fieldName} DESC`)}>Order High  <i className="fas fa-long-arrow-alt-right"></i> Low</DropdownItem>
                </DropdownMenu>
            }
            {!isNumeric &&
                <DropdownMenu>
                    <DropdownItem active={this.state.orderBy === `${fieldName} ASC`} onClick={this.handleSortClick.bind(this, `${fieldName} ASC`)}>Order A <i className="fas fa-long-arrow-alt-right"></i> Z</DropdownItem>
                    <DropdownItem active={this.state.orderBy === `${fieldName} DESC`} onClick={this.handleSortClick.bind(this, `${fieldName} DESC`)}>Order Z <i className="fas fa-long-arrow-alt-right"></i> A</DropdownItem>
                </DropdownMenu>
            }
        </ButtonDropdown>;
    }

    handleProductDeleted(row) {
        this.setState({ rows: list.removeOneReturnArray(this.state.rows, row) });
    }

    handleDropdownProduct(searchFilter) {
        const self = this;
        self.setState({ searchFilter: searchFilter});
    }

    render() {

        let totalRows = 0;
        if (this.state.mode === Constants.MODE_LOADED && this.state.rows) {
            totalRows = this.state.rows.length;
        }

        return (
            <div className="table-search">
                <Header onSearchChanged={this.handleSearchChanged.bind(this)} onChangeDropdown={this.handleDropdownProduct.bind(this)}
                    parentMode={this.state.mode} totalRows={totalRows} />

                {this.state.mode === Constants.MODE_LOADING && <WorkingLayer />}
                {
                    this.state.mode === Constants.MODE_LOADED &&
                    this.state.rows &&
                    this.state.rows.length > 0 &&
                    <div className="table-responsive">
                        <table className="table">
                            <thead className="table-title-row-open">
                                <tr>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            IDP
                                        {this.getSortingDropdown('IDCONTENT', true)}
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            Product name
                                        {this.getSortingDropdown('PRODUCTTITLE', false)}
                                        </div>
                                    </th>
                                    <th></th>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            Brand name
                                        {this.getSortingDropdown('BRAND_NAME', false)}
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            Model No.
                                        {this.getSortingDropdown('MODEL_NO', false)}
                                        </div>
                                    </th>
                                    <th>Keywords in title </th>
                                    <th>Online</th>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            IDC
                                        {this.getSortingDropdown('IDCLIENT', true)}
                                        </div>
                                    </th>
                                    <th>
                                        <div className="d-flex-inline-center">
                                            Company
                                        {this.getSortingDropdown('COMPANY', false)}
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody className="row-hover">
                                {
                                    this.state.rows &&
                                    this.state.rows.map(row => <ProductRow key={row.IDCONTENT} row={row} backofficeUrlBase={this.state.backofficeUrlBase} onProductDeleted={this.handleProductDeleted.bind(this, row)} />)
                                }
                            </tbody>
                        </table>
                    </div>

                }
            </div>
        );
    }
}




